import style from '../OnboardingEgyptLuckyV1.css';
import useTranslation from '../../../../localization/i18n.context';
import Alert from '../../../shared/Alert/Alert';
import Button from '../../../shared/Button/Button';
import TextField from '../../../shared/TextField/TextField';
import Title from '../../../shared/Typography/Title';
import DateField from '../../../shared/DateField/DateField';
import SelectBox from '../../../shared/SelectBox/SelectBox';

const StepField = {
  ID_NUMBER: 'id number caas',
  EXPIRATION_DATE: 'expiration date',
  GENDER: 'gender',
};

export default function FormStep3({ onInputChange, onButtonClick, data = {} }) {
  const { t, language } = useTranslation();

  const isButtonEnabled = Object.values(StepField).every(
    field => data[field] && data[field].value && data[field].value?.trim(),
  );

  return (
    <main className={style.main}>
      <div className={style['form-content']}>
        <div className={style['form-title']}>
          <Title text={t('Enter your ID information')} />
        </div>
        <div className={style['form-alert']}>
          <Alert
            hasIcon
            message={t(
              'Your information must match your ID exactly or it will impact your approval',
            )}
          />
        </div>
        <div className={style['form-inputs']}>
          <div className={style['form-control']}>
            <TextField
              label={t('ID number')}
              type="number"
              placeholder={t('XXXXXXXXXXXX')}
              onInput={onInputChange}
              value={data[StepField.ID_NUMBER]?.value}
              name={StepField.ID_NUMBER}
            />
          </div>

          <div className={style['form-control']}>
            <DateField
              lang={language}
              label={t('Expiration date')}
              type="date"
              onInput={onInputChange}
              value={data[StepField.EXPIRATION_DATE]?.value}
              name={StepField.EXPIRATION_DATE}
            />
          </div>

          <div className={style['form-control']}>
            <SelectBox
              label={t('Gender')}
              title={t('Gender')}
              placeholder={t('Select Gender')}
              name="gender"
              options={[t('MALE'), t('FEMALE')]}
              value={
                data[StepField.GENDER]?.value
                  ? t(data[StepField.GENDER]?.value)
                  : null
              }
              closeOnChange={true}
              onChange={value => {
                let transformedValue = null;

                if (t('MALE') === value) {
                  transformedValue = 'MALE';
                }

                if (t('FEMALE') === value) {
                  transformedValue = 'FEMALE';
                }

                onInputChange({
                  target: { name: StepField.GENDER, value: transformedValue },
                });
              }}
            />
          </div>
        </div>
      </div>
      <div className="fixed-cta">
        <Button fullWidth disabled={!isButtonEnabled} onClick={onButtonClick}>
          {t('Continue')}
        </Button>
      </div>
    </main>
  );
}
FormStep3.Type = 'FormStep3';
FormStep3.EventName = 'ID_number';
